module.exports = __webpack_public_path__ + "e.no2.a59581c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e.no2.jpg
// module id = ddUi
// module chunks = 0